import Aos from 'aos';
import React, { useEffect } from 'react'
import Slider from 'react-slick';

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-arrow next" onClick={onClick}>
            <img src="/assets/services/next.svg" alt="" />
        </div>
    );
};

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-arrow prev" onClick={onClick}>
            <img src="/assets/services/prev.svg" alt="" />
        </div>
    );
};

function FeatureSlider() {
    useEffect(() => {
            Aos.init({
              duration: 1000, // animation duration in ms
              once: true,     // animate only once
            });
          }, []);
    const settings = {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.8,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <Slider {...settings}>
                <div>
                    <div data-aos="fade-up" className='h-[167px] w-[167px] border-[1px] border-[#6953A3] bg-[#FFFFFF] rounded-full flex justify-center items-center'>
                    <h6 className='text-center font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Software Engineer</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='h-[167px] w-[167px] border-[1px] border-[#6953A3] bg-[#FFFFFF] rounded-full flex justify-center items-center'>
                    <h6 className='text-center font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Data Analyst</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='h-[167px] w-[167px] border-[1px] border-[#6953A3] bg-[#FFFFFF] rounded-full flex justify-center items-center'>
                    <h6 className='text-center font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Cloud <br /> Administrator</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='h-[167px] w-[167px] border-[1px] border-[#6953A3] bg-[#FFFFFF] rounded-full flex justify-center items-center'>
                    <h6 className='text-center font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Support </h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='h-[167px] w-[167px] border-[1px] border-[#6953A3] bg-[#FFFFFF] rounded-full flex justify-center items-center'>
                    <h6 className='text-center font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Automation <br /> Tester</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='h-[167px] w-[167px] border-[1px] border-[#6953A3] bg-[#FFFFFF] rounded-full flex justify-center items-center'>
                    <h6 className='text-center font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Salesforce <br /> Developer</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='h-[167px] w-[167px] border-[1px] border-[#6953A3] bg-[#FFFFFF] rounded-full flex justify-center items-center'>
                    <h6 className='text-center font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'> IT <br /> Infrastructure</h6>
                    </div>
                </div>
                <div>
                    <div data-aos="fade-up" className='h-[167px] w-[167px] border-[1px] border-[#6953A3] bg-[#FFFFFF] rounded-full flex justify-center items-center'>
                    <h6 className='text-center font-sans font-[500] text-[24px] tracking-[-0.32px] text-[#000000]'>Business <br /> Analyst</h6>
                    </div>
                </div>
            </Slider>
        </>
    )
}

export default FeatureSlider